export class SessionService {
  constructor() {
    this.authenticationToken = "authenticationToken";
  }

  saveToken(token) {
    sessionStorage.setItem(this.authenticationToken, token);
  }
}
